/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// ============================================================
// Cart Drawer — Cerrar carrito (botón X)
// Delegado en document para funcionar incluso tras cart:refresh
// ============================================================
document.addEventListener('click', function(e) {
  // Detectar click en el botón X o en un hijo suyo (el svg/path)
  var btn = e.target.closest('#shk-cart-close');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  // 1. Ocultar el drawer
  var drawer = document.getElementById('sidebar-cart');
  if (drawer) drawer.setAttribute('aria-hidden', 'true');

  // 2. Quitar el overlay
  var overlay = document.querySelector('.PageOverlay');
  if (overlay) {
    overlay.classList.remove('is-visible');
    overlay.style.opacity = '';
    overlay.style.visibility = '';
  }

  // 3. Restaurar el scroll del body
  document.documentElement.classList.remove('no-scroll');
  document.body.classList.remove('no-scroll');
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
  document.body.style.position = '';
  document.documentElement.style.position = '';
}, true); // useCapture=true para que capture antes que cualquier stop


// ============================================================
// Cart Drawer — Botón regalo gratis (Calcetines + CALCETIN)
// ============================================================
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-action="add-free-gift"]');
  if (!btn) return;
  e.preventDefault();

  var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = 'AÑADIENDO...';

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function (res) { return res.json(); })
  .then(function () {
    // Refresca el carrito usando el evento del tema
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  })
  .catch(function () {
    btn.disabled = false;
    btn.textContent = 'AÑADIR AL CARRITO GRATIS';
  });
});

// ============================================================
// Fix móvil: prevenir salto de scroll al abrir/cerrar acordeones
// iOS Safari hace scroll para mostrar el <summary> al hacer focus,
// lo que provoca que la página suba cuando el usuario scrollea.
// ============================================================
(function () {
  function fixAccordionScroll() {
    var summaries = document.querySelectorAll('.product__accordion summary');
    if (!summaries.length) return;

    summaries.forEach(function (summary) {
      summary.addEventListener('click', function () {
        // Guardar posición actual ANTES de que el navegador haga scroll
        var savedY = window.scrollY || window.pageYOffset;

        // Restaurar en el siguiente frame (después de que iOS haga el scroll)
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            var currentY = window.scrollY || window.pageYOffset;
            // Solo corregir si el salto fue mayor de 30px (evitar falsos positivos)
            if (Math.abs(currentY - savedY) > 30) {
              window.scrollTo({ top: savedY, behavior: 'instant' });
            }
          });
        });
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAccordionScroll);
  } else {
    fixAccordionScroll();
  }
})();


if (window.location.href.indexOf('form_type=customer') > -1) {
  var form = document.getElementById('footer-newsletter_3ACeRB');
  if (form) {
    var paragraph = document.createElement('p');
    paragraph.innerText = 'Este mail ya lo tenemos registrado. Muchas gracias';
    paragraph.setAttribute('class', 'Form__Alert Alert Alert--error');
    form.insertBefore(paragraph, form.firstChild);
  }
}






